import { useLazyQuery, useMutation, useQuery } from "@apollo/client/react";
import { Button, Grid, Chip } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { ButtonOptionGroup } from '../../../components/buttonOptionGroup/ButtonOptionGroup';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { TextInput } from '../../../components/textInput/TextInput';
import { useDebounce } from '../../../hooks/useDebounce';

import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
import { adaptFrecuenciasDistribuidorArray } from '../../../adapters/frecuenciaDistribuidor/frecuenciasDistribuidorAdapter';
import { adaptFrecuenciaDistribuidorArray } from '../../../adapters/frecuenciaDistribuidor/frecuenciaDistribuidorAdapter';
import { adaptDepositoArray } from '../../../adapters/proveedores/depositoAdapter';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { PopoverModal } from '../../../components/popoverModal/PopoverModal';
import { SelectInput } from '../../../components/selectInput/SelectInput';
import { SwitchInput } from '../../../components/switchInput/SwitchInput';
import { CHANGE_STATE_FRECUENCIA_DISTRIBUIDOR } from '../../../data/graphQL/mutations/FrecuenciaDistribuidor/changeStateFrecuenciaDistribuidor';
import { GET_ALL_DEPOSITO } from '../../../data/graphQL/queries/ProveedorDistribuidor/getAllDeposito';
import { GET_ALL_FRECUENCIA_DISTRIBUIDOR } from '../../../data/graphQL/queries/FrecuenciaDistribuidor/getAllFrecuenciaDistribuidor';
import { GET_EXPORT_FRECUENCIA_DISTRIBUIDOR } from '../../../data/graphQL/queries/FrecuenciaDistribuidor/getExportFrecuenciaDistribuidor';
import { GET_FRECUENCIA_DISTRIBUIDOR_BY_ID } from '../../../data/graphQL/queries/FrecuenciaDistribuidor/getFrecuenciaDistribuidorById';
import { getDateToString } from '../../../utils/convert';
import './frecuenciaDistribuidorSearchContent.scss';
import { downloadExcel } from '../../../utils/downloadExcel';

export const FrecuenciaDistribuidorSearchContent = ({ setChildrenAction }) => {
  const navigate = useNavigate();

  const header = ["Deposito", "Distribuidor", "Codigo Postal", "Provincia", "Localidad", "Modo", "Activo"];

  const [depositos, setDepositos] = useState([]);
  const { data: dataDeposito } = useQuery(GET_ALL_DEPOSITO, {
    variables: {
      where: {
        or: [
          { regional: { eq: true } }]

      }
    }
  });

  useEffect(() => {
    if (!dataDeposito) return;
    const selectedDepositos = adaptDepositoArray(dataDeposito);
    const todos = { id: 0, displayName: 'Todos', name: 'Todos' };

    selectedDepositos.push(todos);
    setDepositos(selectedDepositos);
  }, [dataDeposito]);

  const [
    rows,
    setRows,
    selectedActivityFilter,
    setSelectedActivityFilter,
    selectedDepositoFilter,
    setSelectedDepositoFilter,
    handleChangePaginationStatus,
    paginationStatus,
    totalCount,
    filterStatus,
    setFilterStatus] =
    useGetFrecuenciaDistribuidor();

  const debouncedFilterValue = useDebounce(filterStatus, 1000);

  useEffect(() => {
    setChildrenAction(() =>
      <div className='frecuencia-distribuidor-Content'>
        <CustomButton
          className='custom-button'
          variant='outlined'
          size='small'
          onClick={handleExport}>
          Exportar
        </CustomButton>
        <Button
          size='small'
          disableElevation
          onClick={() => navigate('/frecuenciaDistribuidor')}
          variant='contained'>

          Nuevo
        </Button>
      </div>
    );
  }, [setChildrenAction]);

  // TODO: Integrate with backend. This should call the filter query whenever it executes
  useEffect(() => {
  }, [debouncedFilterValue]);

  const handleClickEditFrecuenciaDistribuidor = async (frecuenciaDistribuidor) => {
    await getFrecuenciaDistribuidor({
      variables: {
        IdFrecuenciaDistribuidor: frecuenciaDistribuidor.id
      }
    });
  };

  const initialColumns = [
    {
      headerName: '',
      field: 'action',
      flex: 0.02,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <>
            <PopoverModal>
              <div className='popover-modal-content'>
                <div
                  aria-hidden='true'
                  onClick={() => handleClickEditFrecuenciaDistribuidor(row)}
                  className='item-option clickable-option'>
                  <EditIcon className='edit-icon' />
                  <span className='toggle-action'>Editar</span>
                </div>
                <div className='item-option'>
                  <span className='toggle-action'>Activo</span>
                  <SwitchInput
                    onChange={(e) => changeStateFrecuenciaDistribuidor({
                      variables: {
                        idFrecuenciaDistribuidor: row?.id,
                        state: e.target.checked
                      }
                    })}
                    // Uncomment the checked property when the backend integration is done
                    checked={row?.activo} />

                </div>
              </div>
            </PopoverModal>
          </>);

      }
    },
    {
      field: 'deposito',
      headerName: 'Deposito'
    },
    {
      field: 'distribuidor',
      headerName: 'Distribuidor'
    },
    {
      field: 'codigoPostal',
      headerName: 'C.P.',
      flex: 0.1
    },
    {
      headerName: 'Provincia',
      field: 'provincia'
    },
    {
      headerName: 'Localidad',
      field: 'localidad',
      flex: 0.4,
      valueGetter: (_, row) => row?.localidades?.map((localidad) => localidad).join(", ")
    },
    {
      headerName: 'Modo',
      field: 'modoDespacho',
      flex: 0.1
    },
    {
      field: 'activo',
      type: 'boolean',
      headerName: 'Activo',
      flex: 0.1
    }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), []);

  const [getFrecuenciaDistribuidor, { data: frecuenciaDistribuidor, loading: frecuenciaDistribuidorLoading }] = useLazyQuery(GET_FRECUENCIA_DISTRIBUIDOR_BY_ID, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!frecuenciaDistribuidor) return;
    navigate('/frecuenciaDistribuidor',
      {
        state: {
          FrecuenciaDistribuidor: adaptFrecuenciaDistribuidorArray(frecuenciaDistribuidor)
        }
      });
  }, [frecuenciaDistribuidor]);

  const [getExportFrecuencias, { data: exportFrecuenciasData }] = useLazyQuery(GET_EXPORT_FRECUENCIA_DISTRIBUIDOR, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!exportFrecuenciasData) return;
    const data = exportFrecuenciasData.exportFrecuenciaDistribuidor?.map((item) => {
      let obj = {
        deposito: item?.idDepositoNavigation?.descripcion,
        distribuidor: item?.idProveedorDistribuidorNavigation?.razonSocial,
        codigoPostal: item?.frecuenciaDistribuidorCP[0]?.idCodigoPostalNavigation?.cP,
        provincia: item?.frecuenciaDistribuidorCP[0]?.idCodigoPostalNavigation?.idProvinciaNavigation?.descripcion,
        localidad: item?.frecuenciaDistribuidorCP[0]?.idCodigoPostalNavigation?.localidad,
        modo: item?.idFrecuenciaModoDespachoNavigation?.descripcion,
        activo: Boolean(item?.activo) ? 'Activo' : 'Inactivo'
      };

      return obj;
    });

    downloadExcel({
      fileName: 'Frecuencias',
      sheet: "Frecuencias",
      tablePayload: {
        header,
        body: data
      }
    });
  }, [exportFrecuenciasData]);

  const handleExport = () => {
    getExportFrecuencias();
  };

  const [getFrecuencias, { data: frecuenciasData }] = useLazyQuery(GET_ALL_FRECUENCIA_DISTRIBUIDOR, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!frecuenciasData) return;
    setRows(frecuenciasData);
  }, [frecuenciasData]);

  const [changeStateFrecuenciaDistribuidor] = useMutation(CHANGE_STATE_FRECUENCIA_DISTRIBUIDOR, {
    refetchQueries: () => {
      getFrecuencias({
        variables: {
          skip: paginationStatus.page * paginationStatus.pageSize,
          take: paginationStatus.pageSize,
          // We cast the filter value to boolean because Activo: 0 = false, Inactivo: 1 = true
          where: {
            and: [
              selectedActivityFilter < 2 ? { activo: { eq: !Boolean(selectedActivityFilter) } } : {},
              selectedDepositoFilter > 0 ? { idDeposito: { eq: selectedDepositoFilter } } : {}]

          },
          order: { idFrecuenciaDistribuidor: "DESC" }
        }
      });
    }
  });

  return (
    <div className='assistance-program-container'>
      <Grid
        container
        justifyContent={'space-between'}
        columns={{
          xs: 2,
          md: 8
        }}
        spacing={1}>

        <Grid size={{ xs: 2 }}>
          <TextInput
            placeholder='Buscador'
            value={filterStatus}
            searchIcon
            onChange={(e) => setFilterStatus(e.target.value)}
            onClearButtonClick={() => setFilterStatus('')} />

        </Grid>
        <Grid size={{ xs: 2 }}>
          <SelectInput
            options={depositos}
            label='Deposito'
            onChange={(e) => setSelectedDepositoFilter(e.target.value)}
            value={selectedDepositoFilter}
            name='idDeposito' />

        </Grid>
        <Grid size={{ xs: 1.4 }}>
          <ButtonOptionGroup
            options={['Activos', 'Inactivos', 'Todos']}
            onOptionClick={setSelectedActivityFilter}
            selectedOption={selectedActivityFilter} />

        </Grid>
        <Grid size={{ xs: 2.4 }}>
        </Grid>
      </Grid>
      <Grid
        container
        justifyContent={'space-between'}
        columns={{
          xs: 2,
          md: 8
        }}
        spacing={1}
        marginTop={1}>

        <Grid size={{ xs: 8 }}>
          <DataGridGenerico
            columns={columns}
            rows={rows}
            toolbar={false}
            onPageChange={(page) =>
              handleChangePaginationStatus((prev) => ({
                ...prev,
                page: page
              }))
            }
            onPageSizeChange={(pageSize) =>
              handleChangePaginationStatus((prev) => ({
                ...prev,
                pageSize: pageSize,
                page: 0
              }))
            }
            pageSize={paginationStatus.pageSize}
            totalCount={totalCount}
            currentPage={paginationStatus.page} />

        </Grid>
      </Grid>
    </div>);

};


const useGetFrecuenciaDistribuidor = () => {

  const [frecuencias, setFrecuencias] = useState([]);

  const [selectedActivityFilter, setSelectedActivityFilter] = useState(0);
  const [selectedDepositoFilter, setSelectedDepositoFilter] = useState(0);

  const [paginationStatus, setPaginationStatus] = useState({
    pageSize: 10,
    page: 0
  });

  const [filterStatus, setFilterStatus] = useState('');
  const debouncedFilterValue = useDebounce(filterStatus, 1000);

  const [getFrecuencias, { data: dataFrecuenciasAll, loading: frecuenciasLoading }] = useLazyQuery(GET_ALL_FRECUENCIA_DISTRIBUIDOR, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataFrecuenciasAll) return;
    setFrecuencias(dataFrecuenciasAll);
  }, [dataFrecuenciasAll]);

  useEffect(() => {
    if (!frecuenciasLoading) {
      getFrecuencias({
        variables: {
          skip: paginationStatus.page * paginationStatus.pageSize,
          take: paginationStatus.pageSize,
          // We cast the filter value to boolean because Activo: 0 = false, Inactivo: 1 = true
          where: {
            or: [
              //{ frecuenciaDistribuidorCP: { idCodigoPostalNavigation: { localidad: { contains: debouncedFilterValue } } } },
              { idProveedorDistribuidorNavigation: { razonSocial: { contains: debouncedFilterValue } } }],

            and: [
              selectedActivityFilter < 2 ? { activo: { eq: !Boolean(selectedActivityFilter) } } : {},
              selectedDepositoFilter > 0 ? { idDeposito: { eq: selectedDepositoFilter } } : {}]

          },
          order: { idFrecuenciaDistribuidor: "DESC" }
        }
      });
    }
  }, [selectedActivityFilter, selectedDepositoFilter, paginationStatus, debouncedFilterValue]);
  return [
    adaptFrecuenciasDistribuidorArray(frecuencias?.allFrecuenciaDistribuidor?.items) || [],
    setFrecuencias,
    selectedActivityFilter,
    setSelectedActivityFilter,
    selectedDepositoFilter,
    setSelectedDepositoFilter,
    setPaginationStatus,
    paginationStatus,
    frecuencias?.allFrecuenciaDistribuidor?.totalCount,
    filterStatus,
    setFilterStatus];

};